import React, { useEffect, useState } from 'react'
import FormRender from '../../components/FormRender'
import useAxiosInstance from '../../hooks/useAxios'
import {NEWSLETTER_MIGRATION_FORM_SETTINGS} from '../../helper'
import ReactSelect from 'react-select'

const NewsletterMigration = () => {
    const [formData, setFormData] = useState({
        newsletter_link: "",
        publish_state: "",
        poc: {},
        cc: {},
        export_format: []
    }) 
    const [isSaving, setIsSaving] = useState(false)
    const axiosInstance = useAxiosInstance()
    const [response, setResponse] = useState({})
    const [loading,setIsLoading] = useState(false)

    const ExportSettings =[
        { label: "docx", value: "docx" },
        { label: "pdf", value: "pdf" }
    ]

    const [migrationStatus,setMigrationStatus] = useState('started')
    useEffect(() => {
        if(!response.data){
            return 
        }
        const intervalId = setInterval(() => {
          if (migrationStatus==='completed') {
            clearInterval(intervalId);
            return
          }
          axiosInstance
            .post("/accounts/get_account_creation_status/", {
              activity_logs_pks: [response?.data]
            })
            .then((res) => {
              setMigrationStatus(res?.data.data?.[0]?.status || 'started');
            })
        }, 2500);
    
        return () => {
          clearInterval(intervalId);
        };
    }, [response?.data, migrationStatus])


    const normalizeBoolean = (val) => {
  if (val === "true" || val === true) return true;
  if (val === "false" || val === false) return false;
  return val; 
};

    return (
        <div>
            <div className="mr-4  p-3 my-5 border rounded-lg bg-white">
                <p className="text-2xl text-black font-medium mb-4">Newsletter Export Setting</p>
                {loading ? <p>Loading...</p>:
                <div className="rounded-xl bg-gray-100 p-3">
                    <FormRender
                        formData={formData}
                        formSettings={NEWSLETTER_MIGRATION_FORM_SETTINGS}
                        setFormData={(data) => {
                            setFormData({
                                 ...data,
                                sent_mail: normalizeBoolean(data.sent_mail)
                            });
                      }}
                    />
                       <div className="text-sm py-2 font-semibold mb-2">Export Format:-</div>
                    <ReactSelect
                        options={ExportSettings}
                        value={formData.export_format.map(it=>({label:it,value:it}))}
                        isMulti
                        onChange={(e) => {
                            setFormData({...formData, export_format: e.map(it=>it.value)});
                        }}
                    />
                    <button
                        disabled={isSaving}
                        className='bg-black px-3 mt-4 py-2 rounded text-sm font-sm disabled:bg-[#b6b6b6] disabled:text-black text-white'
                        onClick={() => {
                            setIsSaving(true);
                            setResponse({})
                            setMigrationStatus('started')
                            axiosInstance.post('/newsletter/v2/migrate_newsletter/', formData).then(res => {
                                setIsSaving(false);
                                setResponse(res.data);
                            }).catch(err => {
                                console.log(err);
                            });
                            setIsSaving(false);
                        }}
                    >
                        {isSaving || (!isSaving && migrationStatus === 'started' && response.data)? 'Migrating....' : 'Migrate'}
                    </button>
                </div>}
            </div>
        </div>
    )
}

export default NewsletterMigration;